export enum ReportIntention{
    Report,
    PrintForm
} 